import React from 'react'
import { MDXTag } from '@mdx-js/tag'


import DefaultLayout from "/var/lib/jenkins/jobs/app-styleguide/workspace/src/templates/page.js"
import { Panel } from 'module-tsl-ui-panel';
import { Button } from 'module-tsl-ui-elements';
import WithDocgen from 'module-tsl-ui-panel/with-docs/Panel';
import pkg from 'module-tsl-ui-panel/package.json';
import PropsTable from '../../../components/propsTable';
import Version from '../../../components/version';
import LiveCode from '../../../components/liveCode';

const layoutProps = {
  
};
export default class MDXContent extends React.Component {
  constructor(props) {
    super(props)
    this.layout = DefaultLayout
  }
  render() {
    const { components, ...props } = this.props

    return <MDXTag
             name="wrapper"
             Layout={this.layout} layoutProps={Object.assign({}, layoutProps, props)}
             components={components}>


<MDXTag name="h3" components={components} props={{"id":"example-editable"}}><MDXTag name="a" components={components} parentName="h3" props={{"href":"#example-editable","aria-label":"example editable permalink","class":"anchor"}}></MDXTag>{`example (editable)`}</MDXTag>
<LiveCode
  code={`<Panel className="tds-panel-example">
  <div className="tds-panel__wrapper">
    <h3 className="heading heading--xl heading--bold margin-top-bottom-sm">This is a promo</h3>
    <p className="margin-bottom-md">
      Our smartMatch team can source high-quality candidates for you. It is free to access and you only pay a
      maximum of £2,500 if you appoint the teacher we introduce to you.
    </p>
    <Button theme="primary-dark" type="button">Get in touch</Button>
  </div>
</Panel>`}
  scope={ { Panel, Button } }
/>
<PropsTable data={WithDocgen.__docgenInfo} />
<Version name={'npm i module-tsl-ui-panel --save'} version={pkg.version} />
           </MDXTag>
  }
}

export const _frontmatter = {};

  